module.exports = __webpack_public_path__ + "img/undraw_Upgrade_re_gano.4b22ccc6.png";